import { render, staticRenderFns } from "./ActionButton2.vue?vue&type=template&id=2c4291fc&scoped=true"
import script from "./ActionButton2.vue?vue&type=script&lang=js"
export * from "./ActionButton2.vue?vue&type=script&lang=js"
import style0 from "./ActionButton2.vue?vue&type=style&index=0&id=2c4291fc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c4291fc",
  null
  
)

export default component.exports